import { render, staticRenderFns } from "./work-exp.vue?vue&type=template&id=53eaabca&"
import script from "./work-exp.vue?vue&type=script&lang=js&"
export * from "./work-exp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "work-exp.vue"
export default component.exports